// import * as React from "react";
// import { useEffect, useState, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
import Layout from "../../layouts/default";
// import campaignService from "../../services/campagins";
// import TodayCampaignCard from "./TodayCampaignCard";
// import PaginationList from "../../components/Pagination";
// import styles from "./indexHome.module.css"; 

export const Home = () => {
  // const [campaigns, setCampaigns] = useState([]);
  // const [paginationData, setPaginationData] = useState(null);
  // const [page, setPage] = useState(1);
  // const [loading, setLoading] = useState(true);
  // const navigate = useNavigate();

  // const fetchCampaigns = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const today = new Date().toISOString().split("T")[0];
  //     const filterData = {
  //       status: "published",
  //       scheduledDateTime: today,
  //     };

  //     const result = await campaignService.getCampaigns(page, filterData);

  //     if (result?.data) {
  //       setCampaigns(result.data);
  //       setPaginationData({
  //         total: result.total,
  //         recordsPerPage: result.recordsPerPage,
  //         page,
  //         template: "home",
  //       });
  //     } else {
  //       console.error("Failed to fetch campaigns:", result.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching campaigns:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [page]);

  // useEffect(() => {
  //   fetchCampaigns();
  //   const interval = setInterval(fetchCampaigns, 60000); 
  //   return () => clearInterval(interval);
  // }, [fetchCampaigns]);

  // const handleCampaignClick = (id) => {
  //   navigate(`/campaigns/edit/campaign/${id}`);
  // };

  return (
    <Layout>
      <div>
        <h2>Welcome to the Campaign Portal</h2>

        {/* {loading ? (
          <p>Loading campaigns...</p>
        ) : campaigns.length === 0 ? (
          <p>No campaigns are running today.</p>
        ) : (
          <>
            <div className={styles.campaignList}>
              {campaigns.map((campaign, index) => (
                <TodayCampaignCard
                  index={index + 1}
                  key={campaign.id}
                  campaign={campaign}
                  onClick={handleCampaignClick}
                />
              ))}
            </div>

            {paginationData && (
              <PaginationList
                paginationData={paginationData}
                setPage={setPage}
                setLoading={setLoading}
              />
            )}
          </>
        )} */}
      </div>
    </Layout>
  );
};
